import { arrayOf, object } from 'prop-types'
import React, { Fragment } from 'react'
import HrbTranslate from '../../../components/language/HrbTranslate'
import ScrollingListBox from '../../../components/library/common/ScrollingListBox'
import AssignedListItem from './AssignedListItem'

const AssignedOfficesListBox = props => {

    const { homeOffice, assignedOffices, onAssignedOfficesChanged } = props

    const handleUnassignClicked = officeId => {
        var newAssignedIds = assignedOffices.map(a => a.id).filter(o => o !== officeId)

        if (onAssignedOfficesChanged) {
            onAssignedOfficesChanged(newAssignedIds)
        }
    }

    return (
        <div className='column is-5'>
            <em className='p2 mb-3'>
                <HrbTranslate text='AssociateOfficesModal.AssignedOffices' />
            </em>
            <ScrollingListBox elementId='list-assigned-offices' className='office-list'>
                {(!assignedOffices) &&
                    <Fragment>
                        <AssignedListItem />
                        <AssignedListItem />
                        <AssignedListItem />
                        <AssignedListItem />
                        <AssignedListItem />
                    </Fragment>
                }
                {(homeOffice && assignedOffices) &&
                    <Fragment>
                    <AssignedListItem id={homeOffice.id} label={`${homeOffice.id} - ${homeOffice.name}`} isLocked />
                    {assignedOffices && assignedOffices.map(o =>
                        <AssignedListItem
                            key={o.id}
                            id={o.id}
                            label={`${o.id} - ${o.name}`}
                            onUnassignClicked={handleUnassignClicked} />
                        )}
                    </Fragment>
                }
            </ScrollingListBox>
        </div>
    )
}

AssignedOfficesListBox.propTypes = {
    homeOffice: object,
    assignedOffices: arrayOf(object)
}

export default AssignedOfficesListBox